import * as React from 'react';
import {
  Route,
  BrowserRouter as Router,
  Routes as Switch,
} from 'react-router-dom';
import Landing from '../pages/Landing/Landing';

import Emailverify from '../pages/Emailverify/Emailverify';
import ForgotPassword from '../pages/ForgotPassword/ForgotPassword';
import VerifyUser from '../pages/Emailverify/VerifyUser';
import LogIn from '../pages/LogIn/LogIn';
import SignUp from '../pages/SignUp/SignUp';
import PersonalSignUp from '../pages/SignUp/PersonalSignUp';
import SchoolOptions from '../pages/SignUp/School/SchoolOptions';
import SchoolConnect from '../pages/SignUp/School/SchoolConnect';
import SchoolRegistrationPage from '../pages/SignUp/School/SchoolRegistration';
import ChangePassword from '../pages/ChangePassword/ChangePassword';
import RequireAuth from './RequireAuth';
import Home from '../pages/Home/Home';
import RequireAuthGuest from './RequireAuthGuest';
import LoggedIn from './LoggedIn';
import Quiz from '../pages/Quiz/Quiz';
import Result from '../pages/Result/Result';
import QuizResult from '../pages/Quiz/QuizResult';
import Profile from '../pages/Profile/Profile';
import TermsOfService from '../pages/TermsOfService/TermsOfService';
import AboutUs from '../pages/AboutUs/AboutUs';
import PrivacyPolicy from '../pages/PrivacyPolicy/PrivacyPolicy';
import EditProfile from '../pages/EditProfile/EditProfile';
import DeleteAccount from '../pages/DeleteAccount/DeleteAccount';
import Score from '../pages/Score/Score';
import MyProgress from '../pages/MyProgress/MyProgress';
import PageNotFound from '../pages/PageNotFound/PageNotFound';
import Contactus from '../pages/Contactus/Contactus';
import CleverCallback from '../pages/Home/Callback';
import SchoolRegistration from '../pages/SignUp/SchoolRegestration';
import SchoolAdminDashboard from '../pages/SignUp/SchoolAdminDashboard';
import ResetPassword from '../pages/SignUp/PasswordReset';
import ManageAdmins from '../pages/SignUp/ManageAdmins';
import Pricing from '../pages/Pricing/Pricing';
import QuoteRequest from '../pages/Quote/QuoteRequest';
import SubscriptionPage from '../pages/Subscription/Subscription';
import Newsletter from '../pages/Newsletter/Newsletter';
import MyAccount from '../pages/MyAccount/MyAccount';
import IndianSchoolOnboarding from '../pages/IndianSchoolOnboarding/IndianSchoolOnboarding';
import LandingBkp from '../pages/Landing/LandingBkp';
import LandingBkp2 from '../pages/Landing/LandingBkp2';
import InitialLogin from '../pages/LogIn/InitialLogin';
import SchoolLogin from '../pages/LogIn/SchoolLogin';
import IndividualLogin from '../pages/LogIn/IndividualLogin';
import AdminSchoolUsers from '../pages/SignUp/AdminSchoolUsers';
import AdminReports from '../pages/SignUp/Reports';
import AdminSettings from '../pages/SignUp/Settings';
import Resources from '../pages/SignUp/Resources';

const Routes = (props: any) => {
  return (
    <Switch>
      <Route path="/" element={<LandingBkp2 />} ></Route>
      {/* <Route path="/landing" element={<LandingBkp />}></Route>
      <Route path="/landing2" element={<LandingBkp2 />}></Route> */}
      <Route path="/indian-schools" element={<IndianSchoolOnboarding />}></Route>
      <Route path="/auth/clever/callback" element={<CleverCallback />} />
      <Route
        path="/login"
        element={
          <LoggedIn>
            <LogIn />
          </LoggedIn>
        }
      ></Route>
      <Route
        path="/login-individual"
        element={
          <LoggedIn>
            <IndividualLogin />
          </LoggedIn>
        }
      ></Route>
      <Route
        path="/login-school"
        element={
          <LoggedIn>
            <SchoolLogin />
          </LoggedIn>
        }
      ></Route>
      <Route
        path="/pricing"
        element={
          <Pricing />
        }
      ></Route>
      <Route
        path="/quote-request"
        element={
          <QuoteRequest />
        }
      ></Route>
      <Route
        path="/login/:schoolId"
        element={
          <LoggedIn>
            <LogIn />
          </LoggedIn>
        }
      ></Route>
      <Route
        path="/school-admin-dashboard"
        element={
          <RequireAuthGuest>
            <SchoolAdminDashboard />
          </RequireAuthGuest>
        }
      ></Route>
      <Route
        path="/school-users-management"
        element={
          <RequireAuthGuest>
            <AdminSchoolUsers />
          </RequireAuthGuest>
        }
      ></Route>
            <Route
        path="/school-admin-reports"
        element={
          <RequireAuthGuest>
            <AdminReports />
          </RequireAuthGuest>
        }
      ></Route>
            <Route
        path="/school-admin-settings"
        element={
          <RequireAuthGuest>
            <AdminSettings />
          </RequireAuthGuest>
        }
      ></Route>

      <Route
        path="/resources"
        element={<Resources />}
      ></Route>
      <Route
        path="/manage-admins"
        element={
          <RequireAuthGuest>
            <ManageAdmins />
          </RequireAuthGuest>
        }
      ></Route>
      <Route
        path="/home"
        element={
          <RequireAuthGuest>
            <Home />
          </RequireAuthGuest>
        }
      ></Route>
      <Route
        path="/quiz"
        element={
          <RequireAuthGuest>
            <Quiz />
          </RequireAuthGuest>
        }
      ></Route>
      <Route
        path="/result"
        element={
          <RequireAuthGuest>
            <Result />
          </RequireAuthGuest>
        }
      ></Route>
      <Route
        path="/subscription"
        element={<SubscriptionPage />}
      ></Route>
      <Route
        path="/quizResult"
        element={
          <RequireAuthGuest>
            <QuizResult />
          </RequireAuthGuest>
        }
      ></Route>
      <Route
        path="/signup"
        element={
          <LoggedIn>
            <SignUp />
          </LoggedIn>
        }
      ></Route>
      <Route
        path="/signup-individual"
        element={
          <LoggedIn>
            <PersonalSignUp />
          </LoggedIn>
        }
      ></Route>
      <Route
        path="/signup-school-select"
        element={
          <LoggedIn>
            <SchoolOptions />
          </LoggedIn>
        }
      ></Route>
      <Route
        path="/signup-school-sso"
        element={
          <LoggedIn>
            <SchoolConnect />
          </LoggedIn>
        }
      ></Route>
      <Route
        path="/signup-school-reg"
        element={
          <LoggedIn>
            <SchoolRegistrationPage />
          </LoggedIn>
        }
      ></Route>
      <Route
        path="/register-school"
        element={
          <LoggedIn>
            <SchoolRegistration />
          </LoggedIn>
        }
      ></Route>
      <Route path="/email-verify" element={<Emailverify />}></Route>
      <Route path="/forgot-password" element={<ForgotPassword />}></Route>
      <Route path="/verify-user/:uid" element={<VerifyUser />}></Route>
      <Route
        path="/profile/:tabId?"
        element={
          <RequireAuthGuest>
            <Profile />
          </RequireAuthGuest>
        }
      ></Route>
      <Route path="/terms-of-service" element={<TermsOfService />}></Route>
      <Route path="/about-us" element={<AboutUs />}></Route>
      <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>

      <Route
        path="/contact-us"
        element={
          <RequireAuthGuest>
            <Contactus />
          </RequireAuthGuest>
        }
      ></Route>
      <Route
        path="/profile/edit"
        element={
          <RequireAuthGuest>
            <EditProfile />
          </RequireAuthGuest>
        }
      ></Route>
      <Route
        path="/deleteAccount"
        element={
          <RequireAuth>
            <DeleteAccount />
          </RequireAuth>
        }
      ></Route>
      <Route
        path="/change-password"
        element={
          <RequireAuth>
            <ChangePassword />
          </RequireAuth>
        }
      ></Route>
      <Route
        path="/myProgress"
        element={
          <RequireAuthGuest>
            <MyProgress />
          </RequireAuthGuest>
        }
      ></Route>
      <Route
        path="/score"
        element={
          <RequireAuthGuest>
            <Score />
          </RequireAuthGuest>
        }
      ></Route>
      <Route path="/newsletter" element={<Newsletter />}></Route>
      <Route path="/login" element={<MyAccount />}></Route>
      <Route path="*" element={<PageNotFound />}></Route>
    </Switch>
  );
};
export default Routes;
